export default __webpack_public_path__ + "static/media/slogan3.5e6e630e.png";